import React from "react";
import { Award, Users, CheckCircle, TrendingUp } from "lucide-react";

const TrustSignals = () => {
  const achievements = [
    {
      icon: <Award />,
      title: "USPTO Filing Experts",
      description: "Registered and authorized to practice before the United States Patent and Trademark Office",
    },
    {
      icon: <Users />,
      title: "1000+ Trademarks Filed",
      description: "Successfully filed and registered over 1,000 trademarks for businesses across America",
    },
    {
      icon: <CheckCircle />,
      title: "98% Success Rate",
      description: "Industry-leading approval rate thanks to our thorough preparation and expert legal strategies",
    },
    {
      icon: <TrendingUp />,
      title: "15+ Years Experience",
      description: "Over a decade and a half of specialized expertise in trademark law and brand protection",
    },
  ];

  return (
    <section id="trust-signals" className="trust-signals-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Trusted by Businesses Nationwide</h2>
          <p className="section-subtitle">
            Our Track Record Speaks for Itself
          </p>
        </div>

        <div className="trust-content">
          <div className="trust-image">
            <img 
              src="https://images.pexels.com/photos/6077123/pexels-photo-6077123.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
              alt="Professional legal services and justice" 
              loading="lazy"
            />
          </div>

          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div key={index} className="achievement-card">
                <div className="achievement-icon">{achievement.icon}</div>
                <h4 className="achievement-title">{achievement.title}</h4>
                <p className="achievement-description">{achievement.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="testimonial-section">
          <h3 className="testimonial-heading">What Our Clients Say</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="testimonial-text">
                "trademarkIcontext made the entire process seamless. They handled everything professionally and kept me informed every step of the way. My trademark was registered in just 8 months!"
              </p>
              <div className="testimonial-author">
                <strong>Rebecca Thompson</strong>
                <span>Founder, Luxe Lifestyle Boutique</span>
              </div>
            </div>
            <div className="testimonial-card">
              <p className="testimonial-text">
                "As a tech startup, protecting our brand was crucial. The team's expertise in trademark law gave us peace of mind. They're responsive, knowledgeable, and truly care about their clients."
              </p>
              <div className="testimonial-author">
                <strong>David Kim</strong>
                <span>CEO, NexGen Solutions</span>
              </div>
            </div>
            <div className="testimonial-card">
              <p className="testimonial-text">
                "I tried to file on my own and got lost in the paperwork. trademarkIcontext took over and fixed everything. Their Platinum package was worth every penny for the comprehensive support."
              </p>
              <div className="testimonial-author">
                <strong>Amanda Rodriguez</strong>
                <span>Owner, Artisan Coffee Co.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
